import React from "react";
import IuManagementPageBase from "../../SHARED/components/IuManagementPageBase";
import useInternalUserFeatures from "../../SHARED/hooks/useInternalUserFeatures";
import {
  IU_DATA_MANAGEMENT_LINKS,
  IU_MANAGEMENT_PAGE_TITLE,
} from "../../SHARED/iuManagementPageConfig";

const SimpleUserDataManagement = () => {
  const userFeatures = useInternalUserFeatures();

  return (
    <IuManagementPageBase
      title={IU_MANAGEMENT_PAGE_TITLE.data}
      links={IU_DATA_MANAGEMENT_LINKS}
      filterByFeatures
      userFeatures={userFeatures}
    />
  );
};

export default SimpleUserDataManagement;
